class VwTelediagnosistanimDTO {
    id?: number = 0;
    adi?: string = "";
    fkOrganizasyon?: number = null;
    aciklama?: string = "";
    url?: string = "";
    islemgruplari?: string = "";
}
export default VwTelediagnosistanimDTO;